import { mdiAutoFix } from '@mdi/js'
import { Icon } from '@mdi/react'

const MagicWand = (props) => {
    const { className, color, size = 1, title } = props
    return (
        <Icon
            data-testid="Icon__MagicWand"
            className={className}
            path={mdiAutoFix}
            title={title}
            size={size}
            color={color}
            {...props}
        />
    )
}

export default MagicWand
